var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocplaceLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24H0V0H12ZM3 21H4.5C5.32843 21 6 20.3284 6 19.5C6 18.6716 5.32843 18 4.5 18H3V21ZM3 9H7.5C11.6421 9 15 12.3579 15 16.5C15 18.1244 14.4812 19.6265 13.6035 20.8545C17.8088 20.098 21 16.4231 21 12C21 7.02944 16.9706 3 12 3H3V9ZM3 15H4.5C6.98528 15 9 17.0147 9 19.5C9 19.9545 8.93196 20.3931 8.80664 20.8066C10.6546 20.2467 12 18.5308 12 16.5C12 14.0147 9.98528 12 7.5 12H3V15Z",
    fill: "#0076FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocplaceLogoSm);
export default __webpack_public_path__ + "static/media/DocplaceLogoSm.7ae66631d6bd53b466979d5ea199db99.svg";
export { ForwardRef as ReactComponent };